import React, { Component } from "react";
import Collapsible from "react-collapsible";
import FilterListHeader from "./FilterListHeader";
import Checkbox from "rc-checkbox";
import "../css/checkbox.css";
import Dropdown from "react-dropdown";
import Modal from 'react-modal';
import { FaStar, FaFacebook } from 'react-icons/fa';
import SmallSearchResult from "./SmallSearchResult";
import FloorplanImage from "./FloorplanImage";
import BuyOptions from "./BuyOptions";
import PhotoImage from "./PhotoImage";
import "react-dropdown/style.css";
import "../css/styles.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ReactGA from 'react-ga';


import { css } from 'emotion';
import { ShareButtonRoundSquare, ShareBlockStandard } from 'react-custom-share';

var EventEmitter = require('wolfy87-eventemitter');
var ee = new EventEmitter();

class SearchPlans extends Component {
    constructor(props) {
        super(props);
        this.state = {
            levels_1: false,
            levels_2: false,
            levels_3: false,
            levels_4: false,
            levels_5: false,
            beds_1: false,
            beds_2: false,
            beds_3: false,
            beds_4: false,
            beds_5: false,
            baths_1: false,
            baths_2: false,
            baths_3: false,
            baths_4: false,
            baths_5: false,
            sqft_min: "",
            sqft_max: "",
            style: "All",
            modalIsOpen: false,

            planId: "",//this is the planId being set from the SmallSearchResult component
            currentPlanLevels: "",
            currentPlanBeds: "",
            currentPlanBaths: "",
            currentPlanHalfBaths: "",
            currentPlanThreeQuarterBaths: "",
            currentPlanSqft: "",
            currentPlanFirstFloorSqft: "",
            currentPlanSecondFloorSqft: "",
            currentPlanThirdFloorSqft: "",
            currentPlanFourthFloorSqft: "",
            currentPlanWidth: "",
            currentPlanDepth: "",
            currentPlanFoundations: "",
            currentPlanGarageType: "",
            currentPlanRoofMaterial: "",
            currentPlanSidingMaterial: "",
            currentPlanEnergyEfficiency: "",
            currentPlanRidgeHeight: "",
            currentPlanRoofPitch: "",
            currentPlanMasterBedroomLocation: "",
            currentPlanParking: "",
            currentPlanParkingArea: "",


            offset: 0,
            resultData: [],
            collapsibleIsOpen: false,
            searchingById: false,
            searchPlanId: "",
            planImages: [],
            loadingImages: false,
            navTop: "52px",
            favButtonClicked: false,
            buyOptionsModalIsOpen: false
        };
    }

    render() {
        const options = [
            "All",
            "A-Frame",
            "Adobe",
            "Beach",
            "Bungalow",
            "Cabin & Lodge",
            "Castle",
            "Coastal",
            "Colonial",
            "Contemporary",
            "Cottage",
            "Country",
            "Craftsman",
            "English Country",
            "European",
            "Farm House",
            "French Country",
            "Log Cabin",
            "Mansion",
            "Mediterranean",
            "Mountain",
            "Ranch",
            "Southern",
            "Southern Cottage",
            "Southwestern",
            "Spanish",
            "Sunbelt",
            "Traditional",
            "Vacation",
            "Victorian",
            "Waterfront"
        ];

        var shortDescription = "A " + this.randomDescriptionWord() + " " + this.state.currentPlanBeds + " bed, " + this.state.currentPlanBaths + " bath house plan from houseplanstore.com";

        const shareBlockProps = {
            url: 'https://www.houseplanstore.com/plans/types/houseplans/plan/' + this.state.planId,
            button: ShareButtonRoundSquare,
            buttons: [
                { network: 'Facebook', icon: FaFacebook },
            ],
            text: shortDescription
        };

        var favoritesStorage = localStorage.getItem('favorites');
        var favButtonColor = "#4d4d4d";
        if (!!favoritesStorage) {
            if (favoritesStorage.includes(this.state.planId)) {
                favButtonColor = "#FFFD72";
            }
        }

        if (this.state.favButtonClicked == true) {
            favButtonColor = "#FFFD72";
        }

        return (
            <div>
            {/* <div ref={component => { this.mainDiv = component }} style={{ position: "fixed", top: "0px", left: "0px", right: "0px", bottom: "0px", overflow: "scroll", WebkitOverflowScrolling: "touch" }}> */}
                    <ToastContainer
                        position="top-center"
                        autoClose={1500}
                        hideProgressBar={true}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange={false}
                        draggable={false}
                        pauseOnHover={false}
                    />

                    <div className="filterBar" ref={component => { this.navbar = component }} style={{ position: "fixed", width: 100 + "%", top: this.state.navTop, zIndex: 99 }}>
                        <Collapsible transitionTime={200} open={this.state.collapsibleIsOpen} trigger={<FilterListHeader />}>
                            <div className="filterHolder">
                                <div className="filterColumn">

                                    <div className="filterRow">
                                        <strong>Levels</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.levels_1}
                                                onChange={(e, checked) => {
                                                    this.setState({ levels_1: !this.state.levels_1 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;1
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.levels_2}
                                                onChange={(e, checked) => {
                                                    this.setState({ levels_2: !this.state.levels_2 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;2
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.levels_3}
                                                onChange={(e, checked) => {
                                                    this.setState({ levels_3: !this.state.levels_3 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;3
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.levels_4}
                                                onChange={(e, checked) => {
                                                    this.setState({ levels_4: !this.state.levels_4 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;4
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.levels_5}
                                                onChange={(e, checked) => {
                                                    this.setState({ levels_5: !this.state.levels_5 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;5+
                                </label>
                                    </div>

                                    <div className="filterRow">
                                        <strong>Beds</strong>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.beds_1}
                                                onChange={(e, checked) => {
                                                    this.setState({ beds_1: !this.state.beds_1 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;1
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.beds_2}
                                                onChange={(e, checked) => {
                                                    this.setState({ beds_2: !this.state.beds_2 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;2
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.beds_3}
                                                onChange={(e, checked) => {
                                                    this.setState({ beds_3: !this.state.beds_3 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;3
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.beds_4}
                                                onChange={(e, checked) => {
                                                    this.setState({ beds_4: !this.state.beds_4 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;4
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.beds_5}
                                                onChange={(e, checked) => {
                                                    this.setState({ beds_5: !this.state.beds_5 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;5+
                                </label>
                                    </div>

                                    <div className="filterRow">
                                        <strong>Baths</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.baths_1}
                                                onChange={(e, checked) => {
                                                    this.setState({ baths_1: !this.state.baths_1 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;1
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.baths_2}
                                                onChange={(e, checked) => {
                                                    this.setState({ baths_2: !this.state.baths_2 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;2
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.baths_3}
                                                onChange={(e, checked) => {
                                                    this.setState({ baths_3: !this.state.baths_3 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;3
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                            <Checkbox
                                                checked={this.state.baths_4}
                                                onChange={(e, checked) => {
                                                    this.setState({ baths_4: !this.state.baths_4 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;4
                                </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                            <label>
                                            <Checkbox
                                                checked={this.state.baths_5}
                                                onChange={(e, checked) => {
                                                    this.setState({ baths_5: !this.state.baths_5 });
                                                    this.applySearchResults();
                                                }}
                                            />
                                            &nbsp;5+
                            </label>
                                    </div>

                                    <div className="filterRow">
                                        <strong>Style</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <Dropdown options={options} className="dropDownMenu" onChange={this.onStyleChange} value={this.state.style} placeholder="Select Style" />
                                    </div>

                                    <div className="filterRow">
                                        <strong>Sqft.</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <input
                                            type="number"
                                            className="sqftFilter"
                                            placeholder="Min"
                                            value={this.state.sqft_min}
                                            onChange={e => {
                                                this.setState({ sqft_min: e.target.value });
                                                this.applySearchResults();
                                            }}
                                        />
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                <input
                                            type="number"
                                            className="sqftFilter"
                                            placeholder="Max"
                                            value={this.state.sqft_max}
                                            onChange={e => {
                                                this.setState({ sqft_max: e.target.value });
                                                this.applySearchResults();
                                            }}
                                        />
                                    </div>

                                    <div className="filterRow" style={{ justifyContent: "flex-end", marginBottom: "15px" }}>
                                        <button type="button" className="lightButton btn" onClick={this.resetFilter}>RESET</button>
                                        {/* &nbsp;&nbsp;&nbsp;&nbsp;
                                <button type="button" className="greenButton btn" onClick={this.applySearchResults}>APPLY</button> */}
                                    </div>

                                    <hr style={{ width: 98 + "%", color: "#bbb", backgroundColor: "#bbb" }} />

                                    <p style={{ textAlign: "center" }}><strong>Search by Plan Number</strong></p>
                                    <div className="filterRow" style={{ justifyContent: "flex-end", marginBottom: "10px" }}>

                                        <input
                                            type="text"
                                            className="searchByPlanFilter"
                                            placeholder="Plan #"
                                            value={this.state.searchPlanId}
                                            onChange={e => {
                                                this.setState({
                                                    searchPlanId: e.target.value,
                                                    searchingById: true,
                                                    resultData: []
                                                });
                                                setTimeout(() => {
                                                    this.applySearchByPlanId();
                                                }, 300);
                                            }}
                                        />
                                        {/* &nbsp;&nbsp;&nbsp;
                                <button type="button" className="greenButton smallBtn" onClick={this.searchByPlanId}><FaSearch /></button> */}
                                    </div>


                                </div>
                            </div>
                        </Collapsible>

                        <div onClick={() => { this.setState({ planImages: [] }); setTimeout(() => { this.renderPlanPhotos() }, 300) }} ref={div => (this.planScrollView = div)} className="planScrollView">
                            {this.renderSearchResults()}
                        </div>
                    </div>

                    <div className="mainContentHolder">
                        {this.renderLoadingActInd()}
                        {this.state.planImages}
                    </div>

                    <div onClick={() => { this.faceBookShareClicked() }} className="facebookHolder">
                        <ShareBlockStandard {...shareBlockProps} />
                    </div>

                    <div className="smallPlanInfo">
                        <div style={{ minWidth: "70px" }} className="infoSection"><strong>{this.state.planId}</strong></div>
                        <div className="infoSection">Levels: {this.state.currentPlanLevels}</div>
                        <div className="infoSection">Beds: {this.state.currentPlanBeds}</div>
                        <div className="infoSection">Baths: {this.state.currentPlanBaths}</div>
                        <div className="infoSection">Sqft. {this.state.currentPlanSqft} </div>
                    </div>

                    <div className="buttonHolder">
                        <div onClick={() => { this.openModal() }} className="detailButton">Details</div>
                        <div onClick={() => { this.openBuyOptionsModal() }} className="buyButton">Purchase</div>
                        <div onClick={() => { this.handleFavClick() }} style={{ color: favButtonColor }} className="favoriteButton"><FaStar /></div>
                    </div>

                    <Modal
                        isOpen={this.state.buyOptionsModalIsOpen}
                        ariaHideApp={false}
                        //onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeBuyOptionsModal}
                        style={{ overlay: { backgroundColor: "rgba(0, 0, 0, 0.6)" }, content: { zIndex: 9999 } }}
                        contentLabel="Buy"
                    >
                        <BuyOptions planId={this.state.planId} />
                    </Modal>

                    <Modal
                        isOpen={this.state.modalIsOpen}
                        ariaHideApp={false}
                        //onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeModal}
                        style={{ overlay: { backgroundColor: "rgba(0, 0, 0, 0.6)" }, content: { zIndex: 9999 } }}
                        contentLabel="Details"
                    >
                        <div style={{ fontFamily: 'EB Garamond', fontSize: "21px", fontWeight: "bold" }}>{this.state.planId}</div>
                        {this.renderPlanDetails()}
                    </Modal>
            </div >
        );
    }

    faceBookShareClicked = () => {
        ReactGA.event({
            category: 'User',
            action: 'Facebook Share Clicked',
            label: this.state.planId
        });
    }

    openModal = () => {
        this.setState({ modalIsOpen: true });
    }

    closeModal = () => {
        this.setState({ modalIsOpen: false });
    }

    openBuyOptionsModal = () => {
        this.setState({ buyOptionsModalIsOpen: true });
    }

    closeBuyOptionsModal = () => {
        this.setState({ buyOptionsModalIsOpen: false });
    }

    renderLoadingActInd = () => {
        if (this.state.loadingImages == true) {
            return (
                <div style={{ height: "40px", width: "40px", marginLeft: "auto", marginRight: "auto", marginTop: "30px" }}>
                    <img src={require('../images/rings.gif')} style={{ height: "40px", width: "40px" }} />
                </div>
            );
        } else {
            return null;
        }
    }

    renderPlanDetails = () => {
        var planHtml = [];
        if (this.state.currentPlanLevels !== "0" && !!this.state.currentPlanLevels) {
            planHtml.push(<div key={0} className="detailedInfoRow">Levels: <strong>{this.state.currentPlanLevels}</strong></div>);
        }
        if (this.state.currentPlanBeds !== "0" && !!this.state.currentPlanBeds) {
            planHtml.push(<div key={1} className="detailedInfoRow">Beds: <strong>{this.state.currentPlanBeds}</strong></div>);
        }
        if (this.state.currentPlanBaths !== "0" && !!this.state.currentPlanBaths) {
            planHtml.push(<div key={2} className="detailedInfoRow">Baths: <strong>{this.state.currentPlanBaths}</strong></div>);
        }
        if (this.state.currentPlanHalfBaths !== "0" && !!this.state.currentPlanHalfBaths) {
            planHtml.push(<div key={3} className="detailedInfoRow">Half Baths: <strong>{this.state.currentPlanHalfBaths}</strong></div>);
        }
        if (this.state.currentPlanThreeQuarterBaths !== "0" && !!this.state.currentPlanThreeQuarterBaths) {
            planHtml.push(<div key={4} className="detailedInfoRow">Three Quarter Baths: <strong>{this.state.currentPlanThreeQuarterBaths}</strong></div>);
        }
        if (this.state.currentPlanSqft !== "0" && !!this.state.currentPlanSqft) {
            planHtml.push(<div key={5} className="detailedInfoRow">Total Sqft: <strong>{this.state.currentPlanSqft}</strong></div>);
        }
        if (this.state.currentPlanFirstFloorSqft !== "0" && !!this.state.currentPlanFirstFloorSqft) {
            planHtml.push(<div key={6} className="detailedInfoRow">First Floor Sqft: <strong>{this.state.currentPlanFirstFloorSqft}</strong></div>);
        }
        if (this.state.currentPlanSecondFloorSqft !== "0" && !!this.state.currentPlanSecondFloorSqft) {
            planHtml.push(<div key={7} className="detailedInfoRow">Second Floor Sqft: <strong>{this.state.currentPlanSecondFloorSqft}</strong></div>);
        }
        if (this.state.currentPlanThirdFloorSqft !== "0" && !!this.state.currentPlanThirdFloorSqft) {
            planHtml.push(<div key={8} className="detailedInfoRow">Third Floor Sqft: <strong>{this.state.currentPlanThirdFloorSqft}</strong></div>);
        }
        if (this.state.currentPlanFourthFloorSqft !== "0" && !!this.state.currentPlanFourthFloorSqft) {
            planHtml.push(<div key={9} className="detailedInfoRow">Fourth Floor Sqft: <strong>{this.state.currentPlanFourthFloorSqft}</strong></div>);
        }
        if (this.state.currentPlanWidth !== "0" && !!this.state.currentPlanWidth) {
            planHtml.push(<div key={10} className="detailedInfoRow">Width: <strong>{this.state.currentPlanWidth}</strong></div>);
        }
        if (this.state.currentPlanDepth !== "0" && !!this.state.currentPlanDepth) {
            planHtml.push(<div key={11} className="detailedInfoRow">Depth: <strong>{this.state.currentPlanDepth}</strong></div>);
        }
        if (this.state.currentPlanFoundations !== "0" && !!this.state.currentPlanFoundations) {
            planHtml.push(<div key={12} className="detailedInfoRow">Foundations: <strong>{this.state.currentPlanFoundations.replace(/(^,)|(,$)/g, "")}</strong></div>);
        }
        if (this.state.currentPlanGarageType !== "0" && !!this.state.currentPlanGarageType) {
            planHtml.push(<div key={13} className="detailedInfoRow">Garage Type: <strong>{this.state.currentPlanGarageType.replace(/(^,)|(,$)/g, "")}</strong></div>);
        }
        if (this.state.currentPlanRoofMaterial !== "0" && !!this.state.currentPlanRoofMaterial) {
            planHtml.push(<div key={14} className="detailedInfoRow">Roof Material: <strong>{this.state.currentPlanRoofMaterial.replace(/(^,)|(,$)/g, "")}</strong></div>);
        }
        // if (this.state.currentPlanSidingMaterial !== "0" && !!this.state.currentPlanSidingMaterial) {
        //     planHtml.push(<div className="detailedInfoRow">Siding Material: <strong>{this.state.currentPlanSidingMaterial.replace(/(^,)|(,$)/g, "")}</strong></div>);
        // }
        if (this.state.currentPlanEnergyEfficiency !== "0" && !!this.state.currentPlanEnergyEfficiency) {
            planHtml.push(<div key={15} className="detailedInfoRow">Energy Efficiency: <strong>{this.state.currentPlanEnergyEfficiency}</strong></div>);
        }
        if (this.state.currentPlanRidgeHeight !== "0" && !!this.state.currentPlanRidgeHeight) {
            planHtml.push(<div key={16} className="detailedInfoRow">Ridge Height: <strong>{this.state.currentPlanRidgeHeight}</strong></div>);
        }
        if (this.state.currentPlanRoofPitch !== "0" && !!this.state.currentPlanRoofPitch) {
            planHtml.push(<div key={17} className="detailedInfoRow">Roof Pitch: <strong>{this.state.currentPlanRoofPitch}</strong></div>);
        }
        if (this.state.currentPlanMasterBedroomLocation !== "0" && !!this.state.currentPlanMasterBedroomLocation) {
            planHtml.push(<div key={18} className="detailedInfoRow">Master Bed Location: <strong>{this.state.currentPlanMasterBedroomLocation}</strong></div>);
        }
        if (this.state.currentPlanParking !== "0" && !!this.state.currentPlanParking) {
            planHtml.push(<div key={19} className="detailedInfoRow">Parking: <strong>{this.state.currentPlanParking}</strong></div>);
        }
        if (this.state.currentPlanParkingArea !== "0" && !!this.state.currentPlanParkingArea) {
            planHtml.push(<div key={20} className="detailedInfoRow">Parking Area: <strong>{this.state.currentPlanParkingArea}</strong></div>);
        }
        if (this.state.currentPlanDescription !== "0" && !!this.state.currentPlanDescription) {
            planHtml.push(<div key={21} className="detailedInfoRow"><br /> <strong>Description:</strong> <br /> {this.state.currentPlanDescription}</div>);
        }

        return planHtml;
    }

    getPlanInfo = () => {
        var url = "https://www.houseplanstore.com/web_api/?v=getPlanInfo&planId=" + this.state.planId;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function (e) {
            try {
                var json = JSON.parse(xhr.responseText);
                this.setState({
                    currentPlanLevels: json.levels,
                    currentPlanBeds: json.bedrooms,
                    currentPlanBaths: json.bathrooms,
                    currentPlanHalfBaths: json.half_bathrooms,
                    currentPlanThreeQuarterBaths: json.three_quarter_bathrooms,
                    currentPlanSqft: json.total_sqft,
                    currentPlanFirstFloorSqft: json.first_floor_sqft,
                    currentPlanSecondFloorSqft: json.second_floor_sqft,
                    currentPlanThirdFloorSqft: json.third_floor_sqft,
                    currentPlanFourthFloorSqft: json.fourth_floor_sqft,
                    currentPlanWidth: json.width,
                    currentPlanDepth: json.depth,
                    currentPlanFoundations: json.foundation,
                    currentPlanGarageType: json.garage_type,
                    currentPlanRoofMaterial: json.roof_material,
                    currentPlanSidingMaterial: json.siding_material,
                    currentPlanEnergyEfficiency: json.energy_efficiency,
                    currentPlanRidgeHeight: json.ridge_height,
                    currentPlanRoofPitch: json.roof_pitch,
                    currentPlanMasterBedroomLocation: json.master_bedroom_location,
                    currentPlanParking: json.parking,
                    currentPlanParkingArea: json.parking_area,
                    currentPlanDescription: json.description,
                    favButtonClicked: false
                })
                ReactGA.pageview('/webapp/plans/' + this.state.planId);
            } catch (err) {
                console.log(err);
            }
        }.bind(this)
        xhr.send();
    }

    renderPlanPhotos = () => {
        this.setState({ loadingImages: true });
        var url = "https://www.houseplanstore.com/web_api/?v=getPlanImages&planId=" + this.state.planId;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function (e) {
            try {
                //console.log(xhr.responseText);
                if (xhr.responseText == "" || xhr.responseText == "null") {
                    return;
                }
                var json = JSON.parse(xhr.responseText);

                //make string of all images for gallery
                var allImages = json.main_image + "," + json.floorplan_images + json.other_images;

                var subImages = json.floorplan_images + json.other_images;
                var subImagesArray = subImages.split(",");
                subImagesArray.pop();

                var dataItems = [];
                //push main image first
                var shortDescription = "A " + this.randomDescriptionWord() + " " + this.state.currentPlanBeds + " bed, " + this.state.currentPlanBaths + " bath house plan from houseplanstore.com";

                dataItems.push(<PhotoImage key={0} shortDescription={shortDescription} planId={this.state.planId} image={"https://www.houseplanstore.com/media/" + json.main_image} images={allImages} index={0} />);
                for (var i = 0; i < subImagesArray.length; i++) {
                    if (subImagesArray[i].includes("floorplan")) {
                        dataItems.push(<FloorplanImage key={i + 1} shortDescription={shortDescription} planId={this.state.planId} image={"https://www.houseplanstore.com/media/" + subImagesArray[i]} images={allImages} index={i + 1} />);
                    } else {
                        dataItems.push(<PhotoImage key={i + 1} shortDescription={shortDescription} planId={this.state.planId} image={"https://www.houseplanstore.com/media/" + subImagesArray[i]} images={allImages} index={i + 1} />);
                    }
                }

                this.setState({ planImages: [...this.state.planImages, ...dataItems], loadingImages: false });
                //now get plan info
                this.getPlanInfo();
            } catch (err) {
                console.log(err);
            }
        }.bind(this)
        xhr.send();
    }

    randomDescriptionWord = () => {
        var words = [
            'beautiful',
            'wonderful',
            'charming',
            'stunning',
            'gorgeous'
        ];
        var randomIndex = Math.floor(Math.random() * 10) % words.length;
        return words[randomIndex];
    }

    renderSearchResults = () => {
        var searchResults = [];
        for (var i = 0; i < this.state.resultData.length; i++) {
            var planId = this.state.resultData[i].planId;
            var image = this.state.resultData[i].main_image;
            searchResults.push(<SmallSearchResult key={i} num={i} setState={p => { this.setState(p) }} planId={planId} image={image} />)
        }
        return searchResults;
    }

    handleFavClick = () => {
        this.setState({
            favButtonClicked: true
        });
        var planIds = localStorage.getItem('favorites');
        if (!!planIds) {
            if (!planIds.includes(this.state.planId)) {
                planIds = planIds + this.state.planId + ",";
                localStorage.setItem('favorites', planIds);
            }
        } else {
            localStorage.setItem('favorites', this.state.planId + ",");
        }

        ReactGA.event({
            category: 'User',
            action: 'Added Favorite',
            label: this.state.planId
        });

        toast.info('Plan ' + this.state.planId + ' added to favorites.', {
            position: "top-center",
            autoClose: 1500,
            bodyClassName: "toastFont",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false
        });
    }

    handleResultClick = (planId) => {
        console.log("planId ", planId);
    }

    handleScrollRight = (e) => {
        //console.log("scrollLeft ", this.planScrollView.scrollLeft, "scrollWidth ", (Math.round(((this.state.resultData.length) * 95)) - this.planScrollView.clientWidth) - 121);
        if (this.state.searchingById == false && this.planScrollView.scrollLeft >= (Math.round(((this.state.resultData.length) * 95)) - this.planScrollView.clientWidth) - 121) {
            if (this.state.lockRequest == 0) {
                this.setState({ lockRequest: 1 });
                this.getSearchResults();
            }
        }
        //const items = this.state.items.concat(this.getSearchResults())
        //setTimeout(() => { this.setState({ items }) }, 500)
    };

    handleScroll = (e) => {
        this.lastScrollTop = 0;
        const currentScrollTop = window.scrollY;// this.navbar.scrollTop;

        if (!this.state.hidden && currentScrollTop > this.lastScrollTop) {
            this.setState({ hidden: true });
        } else if (this.state.hidden) {
            this.setState({ hidden: false });
        }
        this.lastScrollTop = currentScrollTop;
    }

    getSearchResultsTest = () => {
        console.log('get search results fired')
    }

    applySearchByPlanId = () => {
        var url = "https://www.houseplanstore.com/web_api/?v=searchByPlanId&planId=" + this.state.searchPlanId;
        console.log(url)
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function (e) {
            try {
                console.log(xhr.responseText);
                if (xhr.responseText == "" || xhr.responseText == "null") {
                    return;
                }
                var json = JSON.parse(xhr.responseText);
                var dataItems = [];
                for (var i = 0; i < Object.keys(json).length; i++) {
                    dataItems.push(json[i]);
                }
                //console.log(dataItems);
                this.setState({
                    resultData: [...this.state.resultData, ...dataItems]
                })
            } catch (err) {
                console.log(err);
            }
        }.bind(this)
        xhr.send();
    }

    getSearchResults = (type) => {
        var url = "https://www.houseplanstore.com/web_api/?v=getSearchResults&levels_1=" +
            this.state.levels_1 +
            "&levels_2=" +
            this.state.levels_2 +
            "&levels_3=" +
            this.state.levels_3 +
            "&levels_4=" +
            this.state.levels_4 +
            "&levels_5=" +
            this.state.levels_5 +
            "&beds_1=" +
            this.state.beds_1 +
            "&beds_2=" +
            this.state.beds_2 +
            "&beds_3=" +
            this.state.beds_3 +
            "&beds_4=" +
            this.state.beds_4 +
            "&beds_5=" +
            this.state.beds_5 +
            "&baths_1=" +
            this.state.baths_1 +
            "&baths_2=" +
            this.state.baths_2 +
            "&baths_3=" +
            this.state.baths_3 +
            "&baths_4=" +
            this.state.baths_4 +
            "&baths_5=" +
            this.state.baths_5 +
            "&sqft_min=" +
            this.state.sqft_min +
            "&sqft_max=" +
            this.state.sqft_max +
            "&style=" +
            this.state.style +
            "&offset=" +
            this.state.offset;
        //console.log(url);
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function (e) {
            try {
                //console.log(xhr.responseText);
                if (xhr.responseText == "" || xhr.responseText == "null") {
                    return;
                }
                var json = JSON.parse(xhr.responseText);
                var dataItems = [];
                if (type == "first") {
                    this.setState({ planId: json[0].planId, planImages: [] })
                    setTimeout(() => { this.renderPlanPhotos() }, 300)
                }

                for (var i = 0; i < Object.keys(json).length; i++) {
                    dataItems.push(json[i]);
                }
                //console.log(dataItems);
                this.setState({
                    resultData: [...this.state.resultData, ...dataItems],
                    offset: this.state.offset + 11,
                    lockRequest: 0
                })
            } catch (err) {
                console.log(err);
            }
        }.bind(this);
        xhr.send();
    };

    onStyleChange = option => {
        this.setState({ style: option.label });
        this.applySearchResults();
    };

    applySearchResults = () => {
        this.setState({
            resultData: [],
            offset: 0,
            collapsibleIsOpen: false,
            searchingById: false,
        });
        setTimeout(() => {
            this.getSearchResults("first");
        }, 300);

    }

    resetFilter = () => {
        this.setState({
            levels_1: false,
            levels_2: false,
            levels_3: false,
            levels_4: false,
            levels_5: false,
            beds_1: false,
            beds_2: false,
            beds_3: false,
            beds_4: false,
            beds_5: false,
            baths_1: false,
            baths_2: false,
            baths_3: false,
            baths_4: false,
            baths_5: false,
            sqft_min: "",
            sqft_max: "",
            style: "All",
            searchPlanId: ""
        });
        this.applySearchResults();
    };

    //   onCheckboxChange = (type) =>{
    //     if(type == "levels_1"){
    //         this.setState({levels_1:})
    //     }
    //   }

    getUrlVars = () => {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    }

    componentDidMount() {
        //read state from cookies
        this.planScrollView.addEventListener("scroll", this.handleScrollRight);
        var prevScrollpos = window.pageYOffset;
        //var prevScrollpos = this.mainDiv.scrollTop;

        // this.mainDiv.onscroll = () => {
        //     var currentScrollPos = this.mainDiv.scrollTop;
        //     console.log("currentScrollPos", currentScrollPos);
        //     console.log("prevScrollpos", prevScrollpos);
        //     if (prevScrollpos > currentScrollPos) {
        //         this.setState({ navTop: "52px" });
        //     } else {
        //         this.setState({ navTop: "-140px" });
        //     }
        //     prevScrollpos = currentScrollPos;
        // }
        window.onscroll = (event) => {
            var currentScrollPos = window.pageYOffset;
            if (prevScrollpos > currentScrollPos) {
                this.setState({ navTop: "52px" });
            } else {
                this.setState({ navTop: "-140px" });
            }
            prevScrollpos = currentScrollPos;

            if(currentScrollPos <= 1){
                this.setState({ navTop: "52px" });
                // console.log("stopPropagation")
                // event.stopPropagation();
            }
        }

        if (this.getUrlVars()["type"] == "plan") {
            this.setState({ planId: this.getUrlVars()["planId"], searchPlanId: this.getUrlVars()["planId"] });
            setTimeout(() => {
                this.applySearchByPlanId();
                this.renderPlanPhotos();
                this.getSearchResults();
            }, 300);
        } else {
            this.getSearchResults("first");
        }



    }

    componentWillUnmount() {

    }

}

export default SearchPlans;
